import gql from 'graphql-tag'

export const PREMIUM_REMINDER_DELETE_MUTATION = gql`
    mutation premiumReminderDelete(
        $id: ID!
    ) {
        premiumReminderDelete(
            id: $id
        ) {
            status
        }
    }
`
